<form [formGroup]="Form" (submit)="onSubmit()" class="mb-6">
  <nz-alert nzType="info"
            nzMessage="Укажите Ваш e-mail, пароль будет выслан на него."
            nzShowIcon></nz-alert>
  <div class="form-group mt-3">
    <input
      (change)="cd.detectChanges()"
      (input)="cd.detectChanges()"
      type="email" [email]="true"
      formControlName="email"
      class="form-control form-control-lg justify-content-between"
      placeholder="example@mail.ru"
      id="username"
    />
  </div>
  <button [disabled]="Form.invalid" [nzBlock]="true" nzSize="large" nzType="primary"
          class="effectMouse effect-white ant-btn-block"
          [nzLoading]="isLoading$ | async"
          nz-button>
    {{(isLoading$ | async) ? ' Проверка...' : 'Восстановить'}}
    <i-feather [style.margin-top.px]="-5" name="log-in"
               class="ml-auto icon-md align-middle"></i-feather>
  </button>
  <!-- Submit -->
  <div class="d-flex justify-content-center mt-3 mb-5">
    <div>
      <i-feather name="chevron-left" class="mr-2 icon-md text-primary"></i-feather>
      <a class="text-underline pointer text-muted"
         (click)="authService.mode$.next('Авторизация')">Войти</a>
    </div>
  </div>

</form>
